export default __webpack_public_path__ + "static/media/organization-icon.72696b70.svg";